var map = {
	"./0.json": 4100,
	"./1.json": 2065,
	"./2.json": 4240,
	"./3.json": 2421,
	"./4.json": 9777,
	"./5.json": 5292,
	"./error.json": 7626,
	"./eye1.json": 1190,
	"./eye2.json": 3025,
	"./spam.json": 5209,
	"./success.json": 5379,
	"./up.json": 921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7343;